import { useQueries, UseQueryOptions } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export function useDocumentAllPages(pages: string[] = [], enabled: boolean = false) {
  const glynt = useGlynt();

  const buildQuery = pages
    .map((page: string) => {
      // remove `?advanced=true` from the end of the string if it's present
      page = page.replace(/\?advanced=true$/, '');
      const regex = /documents\/([^\/]+)\/pages\/([^\/]+)\/$/;
      const matches = page.match(regex);

      // only proceed if we have matches
      if (matches && matches.length === 3) {
        const documentId = matches[1];
        const pageNumber = matches[2];
        return {
          queryKey: ['document-page', documentId, pageNumber],
          queryFn: async () => (await glynt).document.getPage(page),
          staleTime: Infinity,
          refetchOnWindowFocus: false,
          enabled: enabled,
        };
      }
    })
    .filter(Boolean); // Filter out undefined values

  return useQueries({
    queries: buildQuery as UseQueryOptions[]
  });
}
